import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import Modal from '@components/modal/modal'
import { CustomStyle } from './modal-regulation-style'
import * as OnboardingSelector from 'selectors/onboarding/onboarding-selector'

const ModalRegulationTitle = () => (
  <>
    Termos de uso e <br />
    Política de privacidade
  </>
)

const ModalRegulation = ({ isOpened, onClose }) => {
  const regulation = useSelector(OnboardingSelector.companyRegulation)

  const [htmlTerms, setHtmlTerms] = useState('')

  const getContent = async uri => {
    const response = await fetch(uri)
    const responseString = await response.text()
    setHtmlTerms(responseString)
  }

  useEffect(() => {
    getContent(regulation.uri)
  }, [regulation.uri])

  return (
    <Modal className="modal-validation" customTitle={<ModalRegulationTitle />} isOpened={isOpened} onClose={onClose} id="validation">
      <>
        <CustomStyle />

        {regulation.uri ? <div className="regulamento" dangerouslySetInnerHTML={{ __html: htmlTerms }} /> : 'Ops, falha ao exibir o regulamento :('}
      </>
    </Modal>
  )
}

ModalRegulation.propTypes = {
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
  currentRegulation: PropTypes.string,
}
ModalRegulation.displayName = 'ModalRegulation'

export default ModalRegulation
